function productCardImageUrlWithWidth(imageUrl, width) {
  if (!imageUrl) return '';
  var url = imageUrl.split(' ')[0];
  if (/[?&]width=\d+/.test(url)) {
    return url.replace(/([?&])width=\d+/, '$1width=' + width);
  }
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
}

function productCardImageSrcset(imageUrl) {
  if (!imageUrl) return '';
  return [180, 360, 540, 720].map(function (width) {
    return productCardImageUrlWithWidth(imageUrl, width) + ' ' + width + 'w';
  }).join(', ');
}

function applyProductCardMainImage(img, imageUrl) {
  if (!img || !imageUrl) return;
  img.setAttribute('src', productCardImageUrlWithWidth(imageUrl, 360));
  img.setAttribute('srcset', productCardImageSrcset(imageUrl));
}

class ComponentProductCard extends HTMLElement {
  constructor() {
    super()
    this.quickViewBtn = this.querySelector('.quick-view-trigger')
    this.swatches = this.querySelector('.swatch-group')

    if(this.quickViewBtn)
      this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))
    if(this.swatches)
      this.swatches.querySelectorAll('input').forEach((input)=>{
        input.addEventListener('change', this.onSwatchChange.bind(this))
      })
    
    this.replaceTextReview(this.querySelectorAll('product-card .okeReviews-reviewsSummary-ratingCount span[aria-hidden=true]'));    

  }

  openQuickView(e) {
    e.preventDefault()
    $s.showLoadingOverlay();
    $s.getJson({
      url: this.quickViewBtn.dataset.url,
      success: (data)=>{
        $s.openModal(data['main_product'], 'product-quick-view');
        $s.globalEval(data["main_product"]);
      },
      always: (data)=>{
        $s.hideLoadingOverlay();
      }
    })
  }

  onSwatchChange() {
    var checkedOption = this.querySelector('input:checked')
    var variantImg = checkedOption.dataset.variantImg
    var variantUrl = checkedOption.dataset.variantUrl
    var priceFinal = checkedOption.dataset.priceFinal
    var priceCompare = checkedOption.dataset.priceCompare

    this.querySelector('.product-card-url').setAttribute('href', variantUrl)
    this.querySelector('.quick-view-trigger').setAttribute('data-url', variantUrl)
    this.querySelector('.final').innerHTML = priceFinal
    if(this.querySelector('.from')) {
      this.querySelector('.from').style.display = "none"
    }
    if(priceCompare) {
      this.querySelector('.compare').innerHTML = priceCompare
      this.querySelector('.compare').style.display = "block"
    } else {
      this.querySelector('.compare').style.display = "none"
    }
    if (variantImg) {
      var mainImg = this.querySelector('.img.main');
      if (/\d+w/.test(variantImg)) {
        mainImg.setAttribute('srcset', variantImg);
        mainImg.setAttribute('src', variantImg.split(',')[0].trim().split(/\s+/)[0]);
      } else {
        applyProductCardMainImage(mainImg, variantImg);
      }
    }
  }

  replaceTextReview(text){
    text.forEach((t) => {
      let modifiedText = (t.textContent).replace(' Review', '').replace('s', '').replace('(', '').replace(')', '');
      setTimeout(() => {
        t.textContent = '(' + modifiedText + ')';
      }, 1);         
    })        
  }
}
customElements.define('product-card', ComponentProductCard);

class ComponentCardSelector extends ComponentProductCard {
  constructor() {
    super()
    this._userDesiredShade = null;
    this._shadeDrivenSizeChange = false;
    this.planSelector = this.querySelector('[data-plan-selector]') ? this.querySelector('[data-plan-selector]') : false
    this.variantSelector = this.querySelector('[data-variant-selector]') ? this.querySelector('[data-variant-selector]') : false
    this.buttonSelector = this.querySelector('[data-button-selector]') ? this.querySelector('[data-button-selector]') : false
    this.product = JSON.parse(this.querySelector('.product-json [type="application/json"]').textContent)
    this.productJSON = this.querySelector('.product-json [type="application/json"]').textContent
    this.variantSelected = {id: this.product.variants[0].id, selling_plan: ''};
    this.toogleButton = this.parentNode.querySelector('.choose-options');
    this.closeButton = this.querySelector('.close-options');
    this.closeButtonSVG = this.closeButton.firstChild;
    this.firstLoad = true;
    var self = this;

    if (this.variantSelector) {
      this.variantInputs = this.variantSelector.querySelectorAll('label > input')
      this.shadeInputs = this.querySelectorAll('.option-group-name.shade label > input')
      this.sizeInputs = this.querySelectorAll('.option-group-name.size label > input')
      this.sizeSelect = this.querySelector('.option-group-name.size select.size-dropdown')

      this.variantInputs.forEach((input) => {     
        this.variantSelect(this);
        input.addEventListener('change', (e)=>{
          self.variantSelect(self);
        })
      }) 

      if (this.sizeSelect) {
        this.variantSelect(this);
        this.sizeSelect.addEventListener('change', (e)=>{
          self._shadeDrivenSizeChange = false;
          self.variantSelect(self);
          self.checkSizesExtra(self);
        });
        this.initFakeSizeSelect(self);
      } else {
        this.sizeInputs.forEach((input) => {     
          this.variantSelect(this);
          input.addEventListener('change', (e)=>{
            self._shadeDrivenSizeChange = false;
            self.checkSizesExtra(self)
          })
        }) 
      }

      this.shadeInputs.forEach((input) => {     
        this.variantSelect(this);
        input.addEventListener('change', (e)=>{
          self._userDesiredShade = e && e.target ? e.target.value : null;
          self.checkSizes(self);
        })
      }) 
      
    }

    if (this.planSelector) {
      this.planInputs = this.planSelector.querySelectorAll('label > input')
      this.planLabels = this.planSelector.querySelectorAll('label')

      this.planInputChecked = this.planSelector.querySelector('label > [checked]')
      

      this.planLabels.forEach((label) => {     
        label.addEventListener("keypress", function(event) {
          if (event.key === "Enter") {
            event.preventDefault();
            this.querySelector('input').click();
          }
        });
      })   

      this.planInputs.forEach((input) => {
        if (input.checked) {
          self.variantSelected.selling_plan = input.value;
        }
        input.addEventListener('change', (e) => {
          self.variantSelected.selling_plan = e.target.value;
          if (self.planInputChecked) self.planInputChecked.removeAttribute('checked');
          self.buttonsUpdate(self);
        });
      })
    }

    if (this.buttonSelector) {
      this.allTheInputs = this.querySelectorAll('[type="radio"]')
      this.submitButton = this.buttonSelector.querySelector('[type="submit"]');
      this.bisButton = this.buttonSelector.querySelector('.BIS_trigger');
      setTimeout(function(){        
        self.buttonsUpdate(self)
      }, 100);
      this.allTheInputs.forEach((input, i) => {      
        input.addEventListener('change', (e)=>{
          setTimeout(function(){        
            self.buttonsUpdate(self)
          }, 100);
        })
      })
      this.buttonSelector.querySelector('[type="submit"]').addEventListener('click', (e) => {
        e.preventDefault();
        this.productAdd(this.variantSelected);
      })
    }

    if (this.toogleButton) {      
      this.toogleButton.addEventListener('click', (e) => {
        self.closeButtonSVG.style.opacity = '1';
        $s.toggle([e.target.previousElementSibling]);
        $s.trapFocus(this);
      }) 
      this.toogleButton.querySelector('span').addEventListener('click', (e) => {
        self.closeButtonSVG.style.opacity = '1';
        $s.toggle([e.target.parentNode.previousElementSibling]);
        $s.trapFocus(this);
      }) 
      this.toogleButton.querySelector('.sub-price').addEventListener('click', (e) => {
        self.closeButtonSVG.style.opacity = '1';
        $s.toggle([e.target.parentNode.previousElementSibling]);
        $s.trapFocus(this);
      })          
    }
    this.updateChooseOptionsLabel(self);

    if (this.closeButton) {      
      this.closeButton.addEventListener('click', (e) => {        
        self.closeButtonSVG.style.opacity = '0'; 
        this.toogleButton.querySelector('span').style.visibility = "visible";
        this.toogleButton.querySelector('span').style.maxHeight = "100%";
        $s.toggle([self]);             
      })      
    }
    
  }

  normalizeValue(v) {
    return (v || '').toString().trim().toLowerCase();
  }

  updateChooseOptionsLabel(theThis) {
    var self = theThis;
    if (!self.toogleButton || !self.product || !self.product.variants) return;

    var chooseLabel = self.toogleButton.querySelector('[data-choose-options-label]');
    if (!chooseLabel) return;

    var subPrice = self.toogleButton.querySelector('.sub-price');
    var hasAvailableVariant = self.product.variants.some(function(variant) {
      return !!variant.available;
    });

    if (!chooseLabel.dataset.defaultHtml) {
      chooseLabel.dataset.defaultHtml = chooseLabel.innerHTML;
    }

    if (!hasAvailableVariant) {
      chooseLabel.textContent = chooseLabel.dataset.notifyLabel || 'Notify me when available';
      if (subPrice) subPrice.style.display = 'none';
      return;
    }

    chooseLabel.innerHTML = chooseLabel.dataset.defaultHtml;
    if (subPrice) subPrice.style.display = '';
  }

  initFakeSizeSelect(theThis) {
    var self = theThis;
    var wrapper = self.querySelector('.size-select-wrapper');
    var fakeSelect = wrapper && wrapper.querySelector('.fake-size-select');
    if (!fakeSelect) return;

    var realSelect = wrapper.querySelector('select.size-dropdown');
    var trigger = fakeSelect.querySelector('.fake-size-select-trigger');
    var options = fakeSelect.querySelectorAll('.fake-size-option');
    var optionsEl = fakeSelect.querySelector('.fake-size-select-options');
    var inCarousel = !!wrapper.closest('.keen-slider');

    function syncFakeFromReal() {
      var selectedOpt = realSelect.options[realSelect.selectedIndex];
      trigger.textContent = selectedOpt ? selectedOpt.text : 'Select size';
      options.forEach(function(btn) {
        var opt = Array.prototype.find.call(realSelect.options, function(o) { return o.value === btn.dataset.value; });
        btn.disabled = opt ? opt.disabled : true;
      });
    }
    // allow checkSizes() to force a resync after toggling option.disabled
    self._syncFakeSizeFromReal = syncFakeFromReal;

    function openDropdown() {
      fakeSelect.classList.add('open');
      if (inCarousel && optionsEl) {
        var rect = trigger.getBoundingClientRect();
        optionsEl.style.cssText = 'position:fixed;top:' + (rect.bottom + 4) + 'px;left:' + rect.left + 'px;width:' + rect.width + 'px;min-width:' + rect.width + 'px;display:block;z-index:99999;';
        document.body.appendChild(optionsEl);
      }
    }

    function closeDropdown() {
      fakeSelect.classList.remove('open');
      if (inCarousel && optionsEl && optionsEl.parentNode === document.body) {
        optionsEl.style.cssText = '';
        fakeSelect.appendChild(optionsEl);
      }
    }

    function handleTriggerClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (fakeSelect.classList.contains('open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    trigger.addEventListener('click', handleTriggerClick, true);

    options.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (btn.disabled) return;
        realSelect.value = btn.dataset.value;
        realSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncFakeFromReal();
        closeDropdown();
      });
    });

    self.addEventListener('change', function(e) {
      if (e.target === realSelect) syncFakeFromReal();
    });

    document.addEventListener('click', function closeHandler(e) {
      if (!fakeSelect.classList.contains('open')) return;
      var target = e.target;
      if (trigger !== target && !trigger.contains(target) && (!optionsEl || !optionsEl.contains(target))) {
        closeDropdown();
      }
    });

    if (inCarousel) {
      window.addEventListener('scroll', function scrollClose() {
        if (fakeSelect.classList.contains('open')) {
          closeDropdown();
        }
      }, true);
    }

    syncFakeFromReal();
  }

  checkSizes(theThis){
    var self = theThis;  
    var swatch = '';
    if(self.querySelector('.option-group-name.shade input:checked')){
      swatch = self.querySelector('.option-group-name.shade input:checked').value;
    }  
    var swatchNorm = self.normalizeValue(swatch);
    var enabledSizeNorm = [];

    // collect size values from DOM (dropdown or radio inputs)
    var sizeSelect = self.querySelector('.option-group-name.size select.size-dropdown');
    var sizeValueNorms = [];
    if (sizeSelect) {
      Array.prototype.forEach.call(sizeSelect.options, function(opt) {
        if (!opt.value) return;
        sizeValueNorms.push(self.normalizeValue(opt.value));
      });
    } else {
      self.querySelectorAll('.option-group-name.size input').forEach(function(inp) {
        if (!inp.value) return;
        sizeValueNorms.push(self.normalizeValue(inp.value));
      });
    }

    // compute enabled sizes for this shade across all variants
    self.product.variants.forEach((variant) => {
      var variantOpts = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
      var matchesShade = variantOpts.some(function(opt) { return self.normalizeValue(opt) === swatchNorm; });
      if (!matchesShade) return;

      variantOpts.forEach(function(opt) {
        var optNorm = self.normalizeValue(opt);
        if (sizeValueNorms.indexOf(optNorm) !== -1 && enabledSizeNorm.indexOf(optNorm) === -1) {
          enabledSizeNorm.push(optNorm);
        }
      });
    });

    if (sizeSelect) {
      Array.prototype.forEach.call(sizeSelect.options, function(opt) {
        if (!opt.value) return;
        opt.disabled = enabledSizeNorm.indexOf(self.normalizeValue(opt.value)) === -1;
      });
      if (typeof self._syncFakeSizeFromReal === 'function') self._syncFakeSizeFromReal();

      var currentOpt = sizeSelect.options[sizeSelect.selectedIndex];
      var currentValid = currentOpt && currentOpt.value && !currentOpt.disabled;
      if (!currentValid) {
        var firstEnabled = Array.prototype.find.call(sizeSelect.options, function(opt) { return opt.value && !opt.disabled; });
        if (firstEnabled) {
          self._shadeDrivenSizeChange = true;
          sizeSelect.value = firstEnabled.value;
          sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        self.checkSizesExtra(self);
      }
      self.variantSelect(self);
      return;
    }

    // radio size UI
    self.querySelectorAll('.option-group-name.size input').forEach((element) => {
      var enabled = enabledSizeNorm.indexOf(self.normalizeValue(element.value)) !== -1;
      if(!enabled){
        element.parentNode.classList.add('hide');
        element.parentNode.classList.remove('enabled');
      } else {
        element.parentNode.classList.remove('hide');
        element.parentNode.classList.add('enabled');
      }
    });

    var checkedSizeInput = self.querySelector('.option-group-name.size label > input:checked');
    var checkedSizeLabel = checkedSizeInput ? checkedSizeInput.parentNode : null;
    var checkedSizeEnabled = checkedSizeLabel && checkedSizeLabel.classList.contains('enabled') && !checkedSizeLabel.classList.contains('hide');
    if (!checkedSizeEnabled) {
      var firstEnabledSizeLabel = self.querySelector('.option-group-name.size label.enabled:not(.hide)');
      if (firstEnabledSizeLabel) {
        self._shadeDrivenSizeChange = true;
        firstEnabledSizeLabel.click();
      }
    } else {
      self.checkSizesExtra(self);
    }
  }

  checkSizesExtra(theThis){
    var self = theThis;  
    var availableOptions = [];
    var size = '';
    var sizeSelect = self.querySelector('.option-group-name.size select.size-dropdown');
    var sizeInput = self.querySelector('.option-group-name.size input:checked');
    if (sizeSelect) size = sizeSelect.value;
    else if (sizeInput) size = sizeInput.value;
    var desiredShadeNorm = self.normalizeValue(self._userDesiredShade);
    self.product.variants.forEach((variant) => {
      var variantOpts = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
      var matchesSize = variantOpts.some(function(opt) { return self.normalizeValue(opt) === self.normalizeValue(size); });
      if(matchesSize){
        variantOpts.forEach((variantName) => {
          if(!availableOptions.includes(variantName)){
            availableOptions.push(variantName)
          }
        })
      }
    })

    // update shade UI once using all variants that match this size
    var availableNorm = availableOptions.map(function(v) { return self.normalizeValue(v); });
    self.querySelectorAll('.option-group-name.shade input').forEach((element)=>{
      var enabled = availableNorm.indexOf(self.normalizeValue(element.value)) !== -1;
      if(!enabled){
        element.parentNode.classList.add('hide')
        if(element.parentNode.classList.contains('enabled')){
          element.parentNode.classList.remove('enabled');
        }
      }else{
        if(element.parentNode.classList.contains('hide')){
          element.parentNode.classList.remove('hide');
        }
        if(!element.parentNode.classList.contains('enabled')){
          element.parentNode.classList.add('enabled');
        }
      }
    }) 

    var checkedShadeInput = self.querySelector('.option-group-name.shade label > input:checked');
    var checkedShadeLabel = checkedShadeInput ? checkedShadeInput.parentNode : null;
    var checkedShadeEnabled = checkedShadeLabel && checkedShadeLabel.classList.contains('enabled') && !checkedShadeLabel.classList.contains('hide');

    if (checkedShadeEnabled) {
      // keep current shade
    } else if (desiredShadeNorm) {
      // prefer the shade the user clicked, if it's available for this size
      var desiredInput = null;
      self.querySelectorAll('.option-group-name.shade input').forEach(function(inp) {
        if (desiredInput) return;
        if (self.normalizeValue(inp.value) === desiredShadeNorm && inp.parentNode && inp.parentNode.classList.contains('enabled') && !inp.parentNode.classList.contains('hide')) {
          desiredInput = inp;
        }
      });
      if (desiredInput && desiredInput.parentNode) desiredInput.parentNode.click();
      else {
        var firstEnabledShadeLabel = self.querySelector('.option-group-name.shade label.enabled:not(.hide)');
        if (firstEnabledShadeLabel) firstEnabledShadeLabel.click();
      }
    } else {
      var firstEnabledShadeLabel = self.querySelector('.option-group-name.shade label.enabled:not(.hide)');
      if (firstEnabledShadeLabel) firstEnabledShadeLabel.click();
    }

    self._shadeDrivenSizeChange = false;
  }


  variantSelect(theThis){
    var self = theThis;
    self.setValues = '';
    self.setSelectorValues = [];

    var cardRoot = self.closest('[id^="main-product-"]') || self.closest('product-card');
    var img = cardRoot ? cardRoot.querySelector('.img.main') : self.parentElement.querySelector('.img.main');

    var allGroups = self.variantSelector.querySelectorAll('.option-group-name');
    allGroups.forEach((group) => {
      var selectEl = group.querySelector('select.size-dropdown');
      if (selectEl) {
        var val = selectEl.value || null;
        if (val) self.setValues += (self.setValues ? ' / ' : '') + val;
        self.setSelectorValues.push(val);
      } else {
        if (!group.querySelector('label > input:checked')) {
          var checkedInput = group.querySelector('[checked]');
          if (checkedInput) checkedInput.click();
        }
        var checkedInput = group.querySelector('label > input:checked');
        if (checkedInput) {
          var oldChecked = group.querySelectorAll('.checked');
          oldChecked.forEach(function(el) { el.classList.remove('checked'); });
          checkedInput.parentElement.classList.add('checked');
          self.setValues += (self.setValues ? ' / ' : '') + checkedInput.value;
          self.setSelectorValues.push(checkedInput.value);
        } else {
          self.setSelectorValues.push(null);
        }
      }
    });

    self.setValues = self.setValues.trim();
    var selectedOptionEl = self.querySelector('.selected-option-text') || (cardRoot && cardRoot.querySelector('.selected-option-text'));
    if (selectedOptionEl) {
      selectedOptionEl.textContent = self.setValues || '';
      if (self.setValues && self.setValues.trim()) {
        selectedOptionEl.classList.add('has-text');
      } else {
        selectedOptionEl.classList.remove('has-text');
      }
    }

    var matchedVariant = null;
    var numOptions = self.product.options ? self.product.options.length : self.setSelectorValues.length;
    var hasAnySelection = self.setSelectorValues.some(function(sel) { return sel != null && sel !== ''; });
    if (self.setSelectorValues.length === numOptions && hasAnySelection) {
      self.product.variants.forEach((variant) => {
        var variantOpts = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
        if (variantOpts.length !== self.setSelectorValues.length) return;
        var optionsMatch = self.setSelectorValues.every(function(sel, i) {
          return sel == null || sel === '' || sel === variantOpts[i];
        });
        if (optionsMatch && !matchedVariant) {
          matchedVariant = variant;
        }
      });
    }

    if (matchedVariant) {
      if (matchedVariant.selling_plan_allocations && matchedVariant.selling_plan_allocations.length === 0) {
        if (self.querySelector('.one-timer')) self.querySelector('.one-timer').click();
        if (self.querySelector('.subscriptions-wrapper')) self.querySelector('.subscriptions-wrapper').style.display = "none";
      } else if (matchedVariant.selling_plan_allocations) {
        if (self.querySelector('.subscriptions-wrapper')) self.querySelector('.subscriptions-wrapper').style.display = "block";
      }
      self.variantSelected.id = matchedVariant.id;
      if (self.buttonSelector && self.buttonSelector.querySelector('.BIS_trigger')) {
        self.buttonSelector.querySelector('.BIS_trigger').setAttribute('data-variant-id', 'pepoi');
      }
      if (matchedVariant.featured_image && img) {
        applyProductCardMainImage(img, matchedVariant.featured_image.src);
      }
    } else {
      self.variantSelected.id = null;
    }
    self.buttonsUpdate(self);
  }

  buttonsUpdate(theThis){
    var self = theThis;
    var cardPrice = self.parentNode.parentNode.querySelector('.info .price');
    if (!self.variantSelected.id) {
      if (self.submitButton) {
        self.submitButton.disabled = true;
        self.submitButton.style.display = 'block';
        self.submitButton.style.opacity = '0.6';
        //self.submitButton.innerHTML = 'Select size';
      }
      if (self.bisButton) {
        self.bisButton.style.display = 'none';
      }
      self.updateChooseOptionsLabel(self);
      return;
    }
    self.product.variants.forEach((variant) => {
      if (variant.id == self.variantSelected.id){
        if (variant.available) {
          if (self.submitButton) {
            self.submitButton.disabled = false;
            self.submitButton.style.display = 'block';
            self.submitButton.style.opacity = '1';
          }
          if (self.bisButton) {
            self.bisButton.disabled = true;
            self.bisButton.style.display = 'none';
          }
          if (self.variantSelected.selling_plan && variant.selling_plan_allocations && variant.selling_plan_allocations[0] && variant.selling_plan_allocations[0].price_adjustments && variant.selling_plan_allocations[0].price_adjustments[0].price) {
            self.sellingPlanPrice = '$ '+(((variant.selling_plan_allocations[0].price_adjustments[0].price) / 100).toFixed(2));
            if (self.sellingPlanPrice.includes('.00')) {
              self.sellingPlanPrice = self.sellingPlanPrice.slice(0, -3);
            }
            if (self.submitButton) {
              self.submitButton.innerHTML = `Add <span class="small--hide">to bag </span>- ${ variant.compare_at_price ? '<span class="retail">$'+ ((((variant.compare_at_price) / 100).toFixed(2).toString().replace('.00',''))) +'</span>': ''} ${self.sellingPlanPrice}`;
            }
          } else {
            self.defaultPrice = '$ '+(((variant.price) / 100).toFixed(2));
            if (self.defaultPrice.includes('.00')) {
              self.defaultPrice = self.defaultPrice.slice(0, -3);
            }
            if (self.submitButton) {
              self.submitButton.innerHTML = `Add <span class="small--hide">to bag </span>- ${ variant.compare_at_price ? '<span class="retail">$'+ ((((variant.compare_at_price) / 100).toFixed(2).toString().replace('.00',''))) +'</span>': ''} ${self.defaultPrice}`;
            }
          }
        } else {
          if (self.submitButton) {
            self.submitButton.disabled = true;
            self.submitButton.style.display = 'none';
          }
          if (self.bisButton) {
            self.bisButton.style.display = 'block';
            setTimeout(() => {
              self.bisButton.disabled = false;
              self.bisButton.textContent = 'Notify me when available';
            }, 2000);
          }
        }
      }
    });
    self.updateChooseOptionsLabel(self);
  }


  productAdd(variant){ 
    $s.showLoadingOverlay();
    $s.post({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        "items": [
          {
           "id": `${variant.id}`,
           "quantity": "1",
           "selling_plan" : `${variant.selling_plan}`
          }
        ]
      },
      dataType: 'json',
      success: function (data) {
          $s.addToCartSuccess();
          $s.hideLoadingOverlay();
      }
    });
  }

}
customElements.define('card-selector', ComponentCardSelector);